import { useLayoutEffect } from 'react';

import { useButtonPressedCallback } from '@zenbusiness/application-commons-clickstream';

import Box from '@mui/material/Box';

import manifest from '#client/manifest';

import Section from './components/Section';

import { useScript } from './useScript';
import { MT_DATA_TRACKING } from './utils/constants';

const { environment } = manifest;

// TODO: remove schedule section and references after the new Expert help section is completed

const SCHEDULING_SCRIPT = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';
const SCHEDULING_URL = environment === 'local' || environment === 'webpack'
  ? 'https://meetings.hubspot.com/sarah-skelton1?embed=true'
  : 'https://meetings.hubspot.com/marcela-shine/zenbusiness-website-tools?embed=true';

const Scheduling = () => {
  // Append a script to the HTML <head> to be able to embed the scheduling widget
  // REF: https://knowledge.hubspot.com/meetings-tool/embed-the-meeting-widget-on-a-page
  useScript(
    SCHEDULING_SCRIPT,
    {
      removeOnUnmount: true
    }
  );

  const trackClick = useButtonPressedCallback({
    ...MT_DATA_TRACKING,
    elementName: 'meeting_book_succeeded'
  });

  // eslint-disable-next-line consistent-return
  useLayoutEffect(() => {
    // Listen to meeting book succeeded event from hubspot for tracking conversions
    // REF: https://community.hubspot.com/t5/Reporting-Analytics/Tracking-booked-meetings-through-Google-Tag-Manager/m-p/548368/highlight/true#M2934
    const messageHandler = (event) => {
      // Only listen to events from hubspot origin, ignore others origins
      if (event.origin !== 'https://meetings.hubspot.com') {
        return;
      }

      // Track book succeeded event
      if (event.data.meetingBookSucceeded) {
        trackClick(event);
      }
      // Do nothing
    };

    window.addEventListener('message', messageHandler);
    return () => {
      window.removeEventListener('message', messageHandler);
    };
  }, [trackClick]);

  return (
    <Section
      title="Not sure where to start? Get a free marketing consultation"
      description="Book time with our experts to learn what marketing efforts can scale your business."
    >
      <Box
        bgcolor={{
          xs: 'none',
          sm: 'focus10.main'
        }}
        borderRadius={4}
        p={{
          xs: 0,
          sm: 1.5,
          lg: 2
        }}
        boxShadow={{
          xs: 'none',
          sm: '0px 4px 16px 2px rgba(0, 0, 0, 0.12)'
        }}
      >
        <div className="meetings-iframe-container" data-src={SCHEDULING_URL} />
      </Box>
    </Section>
  );
};

export default Scheduling;
